import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-migration/lib";

import { SearchIcon, TextInput } from "@landtechnologies/components";

import { LetterBatchesFilterFormData } from "./LetterBatchesFilterSchema";

export const SearchBatches = () => {
  const { t } = useTranslation();
  const { register, watch } = useFormContext<LetterBatchesFilterFormData>();

  return (
    <div className="atlas-w-64" data-testid="letter-batches-filters-search">
      <TextInput
        size="medium"
        dataTestId="search-batches-input"
        placeholder={t("sites.letter_batches.filters.search_letter_batches")}
        IconLeft={
          <div className="atlas-w-[16px] atlas-h-[16px] atlas-text-neutral-300">
            <SearchIcon />
          </div>
        }
        {...register("search")}
        value={watch("search")}
      />
    </div>
  );
};
